import { none } from 'widgets-for-react';
import { AanZetErrorElement } from "../AanZet/custom_components/components/error";
import { fetchEventsOverviewJumboAanZet, renderAanZetJumbo } from '../AanZet/Features/Events';
import { pushTranslateAction as pushTranslateActionDNB } from '../DeNieuweBibliotheek/custom_components/components/datalayer';
import { DNBErrorElement } from "../DeNieuweBibliotheek/custom_components/components/error";
import { fetchEventsOverviewJumboDNB, renderDNBJumbo } from '../DeNieuweBibliotheek/Features/Events';
import { pushTranslateAction as pushTranslateActionWhiteLabel } from '../Generic/custom_components/components/datalayer';
import { pushTranslateAction as pushTranslateActionRdam } from '../Generic/libraries/rdam/datalayer';
import { GenericErrorElement } from "../Generic/custom_components/components/error";
import { fetchEventsOverviewJumboGeneric, renderGenericJumbo } from '../Generic/Features/Events';
import { collectionSearchUrl as bkwCollectionSearchUrl } from '../Generic/libraries/bkw';
import { collectionSearchUrl as flevoCollectionSearchUrl } from '../Generic/libraries/flevo';
import { collectionSearchUrl as twenteCollectionSearchUrl } from '../Generic/libraries/twente';
import { defaultCollectionConfig } from "./components/Collection/CollectionState";
import { branchBasedLocationFilter, defaultEventsConfig } from './components/Events/EventState';
import { isLibraryID, libraryIDs } from './features/featureSwitch';
import { showOnHome, showOnHomeAndActivities, showOnHomeAndBranch } from './features/showAnnouncementOnPage';
import { WiseConfig } from './features/WiseConfig';
import { fromNullable, valueOrExcept } from './utils/option';
const vbp = {
    automatedTranslations: {
        iconFill: '#090b09',
        pushDataLayerEvent: (label)=>pushTranslateActionWhiteLabel(label)
    },
    collection: 'off',
    events: 'off',
    openingHours: 'drupal',
    search: 'off',
    emptyImageUrl: '/images/empty.png',
    error: GenericErrorElement,
    showAnnouncementOnPage: showOnHome,
    erasmus: 'off'
};
const aanzet = {
    ...vbp,
    automatedTranslations: 'off',
    collection: {
        ...defaultCollectionConfig,
        isInSoftLaunch: false,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/aanzet/logo.svg',
        externalSearchUrl: (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${term}`
    },
    events: {
        ...defaultEventsConfig,
        isInSoftLaunch: false,
        detailPage: {
            ...defaultEventsConfig.detailPage,
            fallbackToHeaderAsPrimary: true
        },
        loadJumbo: fetchEventsOverviewJumboAanZet,
        Jumbo: renderAanZetJumbo
    },
    openingHours: 'google',
    // search: {
    //   route: '/zoeken',
    // },
    error: AanZetErrorElement
};
const bkw = {
    ...vbp,
    collection: {
        ...defaultCollectionConfig,
        isInSoftLaunch: false,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/bkw/logo.svg',
        externalSearchUrl: bkwCollectionSearchUrl
    },
    events: {
        ...defaultEventsConfig,
        isInSoftLaunch: false,
        overviewPage: {
            ...defaultEventsConfig.overviewPage,
            ...branchBasedLocationFilter
        },
        loadJumbo: fetchEventsOverviewJumboGeneric('small'),
        Jumbo: renderGenericJumbo
    },
    showAnnouncementOnPage: showOnHomeAndBranch,
    openingHours: 'google'
};
const dnb = {
    ...vbp,
    automatedTranslations: {
        iconFill: '#ffffff',
        pushDataLayerEvent: (label)=>pushTranslateActionDNB(label)
    },
    collection: {
        ...defaultCollectionConfig,
        isInSoftLaunch: true,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/dnb/logo.svg',
        externalSearchUrl: (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${term}`
    },
    error: DNBErrorElement,
    events: {
        ...defaultEventsConfig,
        isInSoftLaunch: false,
        overviewPage: {
            ...defaultEventsConfig.overviewPage,
            locationFilter: {
                kind: 'location',
                heading: 'Waar',
                defaultLabel: 'Alle locaties'
            }
        },
        detailPage: {
            ...defaultEventsConfig.detailPage,
            collapsePrimaryContent: false
        },
        loadJumbo: fetchEventsOverviewJumboDNB,
        Jumbo: renderDNBJumbo
    }
};
const flevo = {
    ...vbp,
    automatedTranslations: 'off',
    collection: {
        ...defaultCollectionConfig,
        isInSoftLaunch: true,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/flevo/logo.svg',
        externalSearchUrl: flevoCollectionSearchUrl
    },
    events: {
        ...defaultEventsConfig,
        isInSoftLaunch: true,
        loadJumbo: fetchEventsOverviewJumboGeneric('small'),
        Jumbo: renderGenericJumbo
    },
    showAnnouncementOnPage: showOnHomeAndActivities,
    openingHours: 'google'
};
const rdam = {
    ...vbp,
    automatedTranslations: {
        iconFill: '#090b09',
        pushDataLayerEvent: (label)=>pushTranslateActionRdam(label)
    },
    collection: {
        ...defaultCollectionConfig,
        isInSoftLaunch: false,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/rdam/logo.svg',
        externalSearchUrl: (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${term}`
    },
    events: {
        ...defaultEventsConfig,
        overviewPage: {
            ...defaultEventsConfig.overviewPage,
            locationFilter: {
                kind: 'location',
                heading: 'Waar',
                defaultLabel: 'Alle locaties'
            }
        },
        detailPage: {
            ...defaultEventsConfig.detailPage,
            fallbackToHeaderAsPrimary: true,
            copy: {
                noTicketRequired: 'Gratis'
            }
        },
        isInSoftLaunch: false,
        loadJumbo: fetchEventsOverviewJumboGeneric('small'),
        Jumbo: renderGenericJumbo
    },
    erasmus: 'on'
};
const twente = {
    ...vbp,
    automatedTranslations: 'off',
    collection: {
        isInSoftLaunch: false,
        route: '/aanbod',
        coverFallbackImageUrl: '/bkw/images/twente/logo.svg',
        externalSearchUrl: twenteCollectionSearchUrl,
        // There's a couple of school libraries that are are not marked as such in Wise
        // These branches should be excluded from the public catalog
        excludedBranchIds: [
            '5417',
            '5418',
            '5419',
            '5435',
            '5436',
            '5439',
            '5440',
            '5442'
        ]
    },
    events: {
        ...defaultEventsConfig,
        isInSoftLaunch: false,
        overviewPage: {
            ...defaultEventsConfig.overviewPage,
            ...branchBasedLocationFilter
        },
        loadJumbo: fetchEventsOverviewJumboGeneric('large'),
        Jumbo: renderGenericJumbo
    },
    openingHours: 'google',
    showAnnouncementOnPage: showOnHomeAndBranch
};
const libraryCustomizations = {
    vbp,
    aanzet,
    bkw,
    flevo,
    twente,
    dnb,
    rdam
};
// Set application wide Library at runtime
let _features = none();
export const setFeatures = (id)=>{
    if (!isLibraryID(id)) throw new TypeError(`Library ID must be one of: ${libraryIDs.join(', ')}`);
    _features = fromNullable(libraryCustomizations[id]);
};
// Get Features at runtime
export const features = ()=>valueOrExcept(_features, 'Features have not yet been set. Make sure to call features() within the context of the React Application component.');
